<template>
  <div v-if="isChatRoute" v-show="shouldShowChat" id="tdWebchat"></div>
</template>

<script>
import Vue from "vue";
import { addTalkDeskStarterScript } from "@/utils/talkdesk";
import products from "@/utils/consts/products";

export default Vue.extend({
  data: () => ({
    chatStarted: false,
  }),
  computed: {
    isProductSelectionPage() {
      return this.$route.path === "/get-quote";
    },
    shouldShowChat() {
      return !this.isProductSelectionPage && this.isChatRoute && this.isCompleteHealthQuote && !!this.flowId;
    },
    isChatRoute() {
      return (
        (this.$route.path.startsWith("/get-quote") && !this.isProductSelectionPage) ||
        this.$route.path.startsWith("/quote") ||
        this.$route.path.startsWith("/create-account") ||
        this.$route.name === "QuoteCompleteHealth"
      );
    },
    isCompleteHealthQuote() {
      return Number(this.$store.state.productId) === products.COMPLETE_HEALTH;
    },
    flowId() {
      return this.$store.state.config?.unauthenticatedTalkDeskFlowId;
    },
    customerName() {
      return this.$store.state.GetQuote?.members?.[0]?.name || "";
    },
  },
  watch: {
    shouldShowChat: {
      immediate: true,
      handler(shouldShow) {
        if (shouldShow) {
          this.startChat();
        } else if (!this.isChatRoute) {
          this.chatStarted = false;
        }
      },
    },
  },
  methods: {
    startChat() {
      if (this.chatStarted) return;

      this.$nextTick(() => {
        if (!this.shouldShowChat || !document.getElementById("tdWebchat")) return;

        addTalkDeskStarterScript("", this.customerName, "", "", this.flowId);
        this.chatStarted = true;
      });
    },
  },
});
</script>
